export const TemplateLibraryDialogService = Symbol('TemplateLibraryDialogService');
